import { render, staticRenderFns } from "./music-con.vue?vue&type=template&id=2f6c069c&scoped=true&"
import script from "./music-con.vue?vue&type=script&lang=js&"
export * from "./music-con.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c069c",
  null
  
)

export default component.exports